import { Box } from '@mui/system'
import React from 'react'
import { mainHeading, subHeading } from '../../styles/style'
import { Grid, Typography } from '@mui/material'
import { ArrowForwardIos } from '@mui/icons-material'
import TestimonialCard from '../../assets/cards/TestimonialCard'
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/free-mode';
import 'swiper/css/pagination';
import { FreeMode, Pagination } from 'swiper';



export default function Testimonials() {
  return (
    <>
     <Box className="pplacd-container" >
        <Grid container >
          <Grid item md={12} spacing={2} >
           <Box sx={{textAlign:'center', my:5}}>
            <Typography sx={subHeading}>Experience with PPLACD</Typography>
            <Typography sx={mainHeading}>What Our Customers Say About Us</Typography>
            </Box>
            <div className=" my-5`">
          <Swiper
            autoplay
            loop
            spaceBetween={30}
            pagination={{
              dynamicBullets: true,
            }}
            modules={[Pagination]}
            className="mySwiper"
          >
              <SwiperSlide>
           <Grid container spacing={2} mb={6}>
             
                <Grid item md={3}>
                    <TestimonialCard/>
                    </Grid>
                          
                    <Grid item md={3}>
                    <TestimonialCard/>
                    </Grid>
                    <Grid item md={3}>
                    <TestimonialCard/>
                    </Grid>
                    <Grid item md={3}>
                    <TestimonialCard/>
                    </Grid>          
              </Grid>
              </SwiperSlide>
              <SwiperSlide>
           <Grid container spacing={2} mb={6}>
             
                <Grid item md={3}>
                    <TestimonialCard/>
                    </Grid>
                          
                    <Grid item md={3}>
                    <TestimonialCard/>
                    </Grid>
                    <Grid item md={3}>
                    <TestimonialCard/>
                    </Grid>
                    <Grid item md={3}>
                    <TestimonialCard/>
                    </Grid>          
              </Grid>
              </SwiperSlide>
              <SwiperSlide>
           <Grid container spacing={2} mb={6}>
             
                <Grid item md={3}>
                    <TestimonialCard/>
                    </Grid>
                          
                    <Grid item md={3}>
                    <TestimonialCard/>
                    </Grid>
                    <Grid item md={3}>
                    <TestimonialCard/>
                    </Grid>
                    <Grid item md={3}>
                    <TestimonialCard/>
                    </Grid>          
              </Grid>
              </SwiperSlide>
          </Swiper>
        </div>
             
                 
                           
               
            <Box className="flexbgbtn">
              <button className="bgbtn" type="button">
                View More <ArrowForwardIos sx={{ fontSize: "16px" }} />{" "}
              </button>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </>
  )
}
